import { render, staticRenderFns } from "./PublicationTabBar.vue?vue&type=template&id=1935d1fb"
import script from "./PublicationTabBar.vue?vue&type=script&lang=js"
export * from "./PublicationTabBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports